import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { bruttoNettoCalculatorRoutes } from '@metallgehalt/brutto-netto-calculator';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(bruttoNettoCalculatorRoutes)],
  exports: [RouterModule]
})
export class BruttoNettoRoutingModule {}
